import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["linkInput", "messageTextarea", "copyLinkButton", "emailFooter"]
  static values = { url: String, linkedInPost: String }

  copyLink() {
    navigator.clipboard
      .writeText(this.urlValue)
      .then(() => {
        this.showCopiedFeedback(this.copyLinkButtonTarget)
      })
      .catch(() => {
        this.showCopyFailedFeedback(this.copyLinkButtonTarget)
      })
  }

  shareWhatsApp() {
    const encoded = encodeURIComponent(this.messageTextareaTarget.value)
    window.open(`https://api.whatsapp.com/send?text=${encoded}`, "_blank", "noopener,noreferrer")
  }

  shareLinkedIn() {
    const post = this.linkedInPostValue || ""
    window.open(
      `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(post)}`,
      "_blank",
      "noopener,noreferrer"
    )
  }

  showFooter() {
    this.emailFooterTarget.classList.remove("d-none")
  }

  hideFooter() {
    this.emailFooterTarget.classList.add("d-none")
  }

  showCopyFailedFeedback(button) {
    const originalHTML = button.innerHTML
    const label = button.dataset.copyFailedLabel || "Failed to copy"
    button.innerHTML = `<span class="material-symbols-outlined me-1" style="font-size: 18px; vertical-align: text-bottom;">error</span> ${label}`
    setTimeout(() => {
      button.innerHTML = originalHTML
    }, 2000)
  }

  showCopiedFeedback(button) {
    const originalHTML = button.innerHTML
    const label = button.dataset.copiedLabel || "Copied"
    button.innerHTML = `<span class="material-symbols-outlined me-1" style="font-size: 18px; vertical-align: text-bottom;">check</span> ${label}`
    setTimeout(() => {
      button.innerHTML = originalHTML
    }, 2000)
  }
}
